import styled from 'styled-components';

export const ContactInputGroup = styled.div`
  margin-top: -1rem;
`;
